import { Component, ChangeDetectionStrategy } from '@angular/core';
import { MatProgressBarModule } from '@angular/material/progress-bar';

@Component({
    selector: 'app-buffer-progress-bar',
    imports: [MatProgressBarModule],
    changeDetection: ChangeDetectionStrategy.Default,
    templateUrl: './buffer-progress-bar.component.html'
})
export class BufferProgressBarComponent {}
